module.exports = __webpack_public_path__ + "img/20m1.8a357f11.jpg";